import UploaderLoginComponent from './uploaderLogin.component';

export const uploaderLoginModule = {
	name: 'uploaderLoginComponent',
};

export default angular
	.module(uploaderLoginModule.name, [])
	.component('uploaderLogin', new UploaderLoginComponent()).name;
